import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { getProductKeyFromCTType } from "@grandvisionhq/utils";
import { updatePurchaseType } from "./actions.js";
import { productDetailContextReducer, initialState } from "./reducer.js";
import { isSubscriptionPurchase, isInStoreSubscriptionPurchase } from "../../types/types/typeguards.js";
import { getDisplayPrice } from "../../utils/utils/get-display-price.js";
const ProductContext = React.createContext(
  {}
);
ProductContext.displayName = "ProductContext";
function ProductProvider({
  children,
  sku,
  selfUrl,
  product,
  routes,
  facetConfigList,
  specificationConfiguration,
  bookAppointmentRouteConfig
}) {
  const { variants } = product;
  const [state, dispatch] = React.useReducer(productDetailContextReducer, {
    ...initialState,
    activeSku: sku
  });
  const activeVariant = React.useMemo(
    // @ts-expect-error ts(2349)
    () => variants.find((variant) => variant.sku === state.activeSku) || variants[0],
    [state, variants]
  );
  const { selectedPurchaseType } = state;
  React.useEffect(() => {
    const { isAvailableForInStoreSubscription, isAvailableForSubscription } = activeVariant;
    if (isSubscriptionPurchase(selectedPurchaseType) && !isAvailableForSubscription || isInStoreSubscriptionPurchase(selectedPurchaseType) && !isAvailableForInStoreSubscription) {
      dispatch(updatePurchaseType({ purchaseType: "single-purchase" }));
    }
  }, [activeVariant, selectedPurchaseType]);
  const displayPrice = React.useMemo(
    () => getDisplayPrice(activeVariant, state),
    [activeVariant, state]
  );
  const productLink = useLink({
    route: "products.detail",
    params: {
      slug: activeVariant.slug,
      sku: activeVariant.sku,
      key: getProductKeyFromCTType(product.productType)
    }
  });
  const productUrl = `${selfUrl}${productLink?.href}`;
  const value = React.useMemo(
    () => ({
      activeVariant,
      bookAppointmentRouteConfig,
      dispatch,
      displayPrice,
      facetConfigList,
      product,
      productUrl,
      routes,
      selectedPurchaseType,
      specificationConfiguration
    }),
    [
      activeVariant,
      bookAppointmentRouteConfig,
      displayPrice,
      facetConfigList,
      product,
      productUrl,
      routes,
      selectedPurchaseType,
      specificationConfiguration
    ]
  );
  return /* @__PURE__ */ React.createElement(ProductContext.Provider, { value }, children);
}
export {
  ProductContext,
  ProductProvider
};
//# sourceMappingURL=ProductContext.js.map
